"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactSizeme = _interopRequireDefault(require("react-sizeme"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _classnames2 = _interopRequireDefault(require("classnames"));
var _reactRedux = require("react-redux");
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var cacheWidth = 100;
var ProgressBar = function ProgressBar(props) {
  var playerSettings = props.playerSettings,
    progressBarPercent = props.progressBarPercent,
    segmentedProgressBar = props.segmentedProgressBar,
    goToComponent = props.goToComponent,
    size = props.size;
  var width = size.width || cacheWidth;
  cacheWidth = width;
  var isPresenterMode = (0, _reactRedux.useSelector)(function (state) {
    return state.flow.player.isPresenterMode;
  });

  // we need transform for iOS bug fix
  var simpleBar = /*#__PURE__*/_react["default"].createElement("div", {
    className: "progress",
    style: {
      margin: '0px',
      transform: 'rotate(0.02deg)'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "progress-bar progress-bar-primary",
    style: {
      width: progressBarPercent + '%'
    }
  }));
  if (playerSettings.useSegmentedProgressBar) {
    if (width < 600) {
      var content = /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].segmentedList
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "btn-group-vertical"
      }, segmentedProgressBar.map(function (item) {
        return /*#__PURE__*/_react["default"].createElement("button", _extends({
          key: item.id,
          type: "button",
          className: (0, _classnames2["default"])('btn btn-secondary', {
            'btn-primary': item.isCurrent || item.progress === 'past',
            active: item.isCurrent
          }),
          style: {
            whiteSpace: 'normal'
          },
          disabled: item.progress === 'future'
        }, item.progress === 'past' ? {
          onClick: function onClick() {
            return goToComponent(item.id);
          }
        } : {}), item.tooltip);
      })));
      return /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        title: content,
        maxWidth: "100vw",
        tippyProps: {
          theme: 'light',
          interactive: true,
          appendTo: document.body
        }
      }, simpleBar);
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].segmentedProgressBar
    }, segmentedProgressBar.map(function (item) {
      return /*#__PURE__*/_react["default"].createElement("div", _extends({
        key: item.id,
        className: (0, _classnames2["default"])(_style["default"].item, _defineProperty(_defineProperty({}, _style["default"].past, item.progress === 'past' || isPresenterMode), _style["default"].isCurrent, item.isCurrent)),
        style: {
          width: item.width,
          minWidth: '5px'
        }
      }, item.progress === 'past' || isPresenterMode ? {
        onClick: function onClick() {
          return goToComponent(item.id);
        }
      } : {}), item.tooltip ? /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        key: item.id,
        title: item.tooltip,
        tippyProps: {
          hideOnClick: false,
          appendTo: 'parent'
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].tooltipTrigger
      })) : null);
    }));
  }
  return simpleBar;
};
var _default = exports["default"] = (0, _reactSizeme["default"])({
  refreshRate: 100,
  noPlaceholder: true
})(ProgressBar);